import './index.css';

const Copyright = () => {
    return (
        <div className="copyright">
            © 2022 上海华星秋月文化创意有限公司. All rights reserved.
        </div>
    )
};

export default Copyright;